import React from "react";
import { FiMoon, FiSun } from "react-icons/fi";
import useThemeStore from "hooks/useThemeStore";
import "./themeToggle.scss";

/**
 * Sakelar mode gelap. Ditempatkan di kaki sidebar, tepat di atas Logout.
 *
 * Memakai <button role="switch"> ketimbang <input type="checkbox"> supaya
 * seluruh baris bisa diklik, dan `aria-checked` tetap memberi tahu pembaca
 * layar status hidup/matinya.
 */
const ThemeToggle = () => {
  const isDark = useThemeStore((state) => state.isDark);
  const toggleTheme = useThemeStore((state) => state.toggleTheme);

  return (
    <button
      type="button"
      className="theme-toggle"
      role="switch"
      aria-checked={isDark}
      onClick={toggleTheme}
    >
      <span className="theme-toggle-icon" aria-hidden="true">
        {isDark ? <FiMoon /> : <FiSun />}
      </span>
      <span className="theme-toggle-label">Mode Gelap</span>
      {/* Sakelarnya dekoratif: statusnya sudah disampaikan lewat aria-checked
          di tombol induknya, jadi tidak perlu dibacakan dua kali. */}
      <span className="theme-toggle-track" aria-hidden="true">
        <span className="theme-toggle-knob" />
      </span>
    </button>
  );
};

export default ThemeToggle;
